import { END_POINT } from '../end-point';
import { httpService } from '../util/axiosRequests';
import { getAccessTokenFromCookies } from 'lib/utils/setTokensInCookies';

const itemAPI = {
  // 디지털기기 추가
  postDigitalDevicesAPI: async (data: any) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.post<any>(END_POINT.digitalDevicesController.postDigitalDevices(), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response;
    } catch (error) {
      // console.error('postDigitalDevicesAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },

  // 디지털기기 삭제
  deleteDigitalDevicesAPI: async (itemId: number) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.delete<any>(END_POINT.digitalDevicesController.deleteDigitalDevices(itemId), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer 형식으로 Authorization 헤더에 추가
          Accept: 'application/json' // 필요에 따라 Accept 헤더 추가 가능
        }
      });

      return response;
    } catch (error) {
      // console.error('deleteDigitalDevicesAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 디지털기기 변경
  putDigitalDevicesAPI: async (itemId: number, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.put<any>(END_POINT.digitalDevicesController.putDigitalDevices(itemId), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer 형식으로 Authorization 헤더에 추가
          Accept: 'application/json' // 필요에 따라 Accept 헤더 추가 가능
        }
      });

      return response;
    } catch (error) {
      // console.error('putDigitalDevicesAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  getBusinessPlacesAPI: async () => {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(END_POINT.businessPlacesController.getBusinessPlaces(), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response.data;
    } catch (error) {
      // console.error('getBusinessPlacesAPI 조회 실패 :', error);
      console.error(error);
      throw error;
    }
  },
  // 사업장 추가
  postBusinessPlacesAPI: async (data: any) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.post<any>(END_POINT.businessPlacesController.postBusinessPlaces(), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response;
    } catch (error) {
      // console.error('postBusinessPlacesAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },

  // 사업장 삭제
  deleteBusinessPlacesAPI: async (itemId: number) => {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.delete<any>(END_POINT.businessPlacesController.deleteBusinessPlaces(itemId), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer 형식으로 Authorization 헤더에 추가
          Accept: 'application/json' // 필요에 따라 Accept 헤더 추가 가능
        }
      });
      return response;
    } catch (error) {
      // console.error('deleteBusinessPlacesAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },

  // 사업장 변경
  putBusinessPlacesAPI: async (itemId: number, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.put<any>(END_POINT.businessPlacesController.putBusinessPlaces(itemId), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer 형식으로 Authorization 헤더에 추가
          Accept: 'application/json' // 필요에 따라 Accept 헤더 추가 가능
        }
      });
      return response;
    } catch (error) {
      // console.error('putBusinessPlacesAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  }
};

export const {
  postDigitalDevicesAPI,
  deleteDigitalDevicesAPI,
  putDigitalDevicesAPI,

  getBusinessPlacesAPI,
  postBusinessPlacesAPI,
  deleteBusinessPlacesAPI,
  putBusinessPlacesAPI
} = itemAPI;
